import React from 'react';
import css from '../fields/total-area.module.css';

interface Props {
  name: string;
  count: number;
  units?: string;
}

export default function DashboardTotal({ name, count, units }: Props) {
  return count ? (
    <div className={css['total-area']}>
      <span className={css['name']}>{name}</span>
      <span className={css['count']}>
        {count} {units}
      </span>
    </div>
  ) : null;
}
